import { render, staticRenderFns } from "./UserGlobalAlert.vue?vue&type=template&id=c057f15c&"
import script from "./UserGlobalAlert.vue?vue&type=script&lang=js&"
export * from "./UserGlobalAlert.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/www/cabcom.dashtogo.com/laravel/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c057f15c')) {
      api.createRecord('c057f15c', component.options)
    } else {
      api.reload('c057f15c', component.options)
    }
    module.hot.accept("./UserGlobalAlert.vue?vue&type=template&id=c057f15c&", function () {
      api.rerender('c057f15c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/csmworkflow/js/views/UserGlobalAlert.vue"
export default component.exports